import React from 'react'

const Home = () => <div style={{ textAlign: 'center', color: 'white' }}>
  <h1 className="runner" >RUNNER.THAI.RUN</h1>
</div>

export default Home
